import React, { useEffect, useState } from 'react';
import { isSafari } from 'react-device-detect';
import axios from 'axios';
import { useAuth } from '../../../context/auth';
import { Type } from '../../../types';
import {
    InformationTitle,
    InformationDescription,
    InformationWrapper,
    InformationName
} from '../../CampaignDetails.styles';
import {
    StyledInformationName,
    Image,
    StyledLink,
    ImageBig
} from './Content.styles';
import { ContentProps, AnswerType } from './Content.interface';

export function Content({ adType, details }: ContentProps) {
    const [videoBlobUrl, setVideoBlobUrl] = useState<string | null>(null);
    const { user } = useAuth();
    const changeCampaignType = (type: string) => {
        switch (type) {
            case 'Small banner':
                return 'Medium Rectangle';
            case 'Big banner':
                return 'Leaderboard';
            default:
                return type
        }
    }
    const redirectOutsite = (path: string) => {
        if (!path.match(/^https?:\/\//i)) {
            path = 'http://' + path;
        }
        return window.open(path, '_target');
    }
    const getVideoBlob = (videoUrl: string) => {
        axios.get(videoUrl, { responseType: 'arraybuffer'}).then((res) => {
            let blob = new Blob([res.data], { type: 'video/mp4' });
            let url = URL.createObjectURL(blob);
            setVideoBlobUrl(url);
        })
    }
    useEffect(() => {
        if (isSafari && details.mediaFile && adType === 'Video') {
            getVideoBlob(details.mediaFile);
        }
    }, [])
    return (
        <div>
            <InformationTitle>Content</InformationTitle>
            <InformationWrapper>
                <InformationName>Type of campaign</InformationName>
                <InformationDescription>{changeCampaignType(adType)}</InformationDescription>
                <StyledInformationName>Description</StyledInformationName>
                <InformationDescription>{details.description}</InformationDescription>
                {adType === Type.Video 
                    ? 
                        <>
                            <StyledInformationName>Media</StyledInformationName>
                            <video 
                                width="100%" 
                                height="auto" 
                                autoPlay 
                                muted 
                                loop 
                                src={(isSafari && videoBlobUrl ) ? videoBlobUrl : details.mediaFile}
                                controls={user ? user.isAdmin : false}>
                            </video>
                        </>
                    : adType === Type.BigBanner ?
                        <>
                            <StyledInformationName>Desktop file</StyledInformationName>
                            <ImageBig src={details.desktopFile} alt="Campaign image" />
                            <StyledInformationName>Mobile file</StyledInformationName>
                            <Image src={details.mobileFile} alt="Campaign image" type={adType} />
                        </>
                        : 
                            <>
                                <StyledInformationName>Media</StyledInformationName>
                                <Image src={details.mediaFile} alt="Campaign image" type={adType} />
                            </>

                }
                {adType === Type.Poll && 
                    <>
                        <StyledInformationName>Poll Question</StyledInformationName>
                        <InformationDescription>
                            {details.pollQuestion}
                        </InformationDescription>
                        <StyledInformationName>Poll Answers</StyledInformationName>
                        {details.answers?.map((answer: AnswerType) => (
                            <InformationDescription key={answer.id}>{answer.questionAnswer}</InformationDescription>
                        ))}
                        
                        <StyledInformationName>Post-voting Message</StyledInformationName>
                        <InformationDescription>
                            {details.postVotingMessage}
                        </InformationDescription>
                    </>
                }
                <StyledInformationName>Redirect Link</StyledInformationName>
                <StyledLink onClick={() => redirectOutsite(details.redirectLink)}>{details.redirectLink}</StyledLink>
            </InformationWrapper>
        </div>
    )
}
